import SectionContent from "./SectionContent";
import DisplaySummary from "./DisplaySummary";


export default function SummaryComponent({ summaryData}) {
//  let summaryData = JSON.parse(localStorage.getItem("summaryData"));
//   console.log(summaryData)
 
  if(!summaryData || summaryData.length === 0) return null;
  return (
   <SectionContent subTitle={"- AI generated Weekly Feedback Summaries." }> 
    {summaryData.length === 0 && <p style={{color:"gray",fontStyle:"italic"}}>No summaries to show yet.</p>}

    {summaryData.map((item) => {
        // let branchInfo = getBranchInfobyId(item.admin_id);
        return (
            <div key={item.admin_id}>
                  <DisplaySummary branchId={item.admin_id} summary={item.summary} />
            </div>
        );
    })}
 
   </SectionContent>
  );
}